import { Controller } from "@hotwired/stimulus"

// Inline expand-to-confirm. Shows the "Are you sure?" row in place of
// the initial trigger button. Cancel restores the trigger; the actual
// destructive action lives on a separate confirm button.
export default class extends Controller {
  static targets = ["trigger", "confirm"]

  show(event) {
    event.preventDefault()
    this.triggerTarget.hidden = true
    this.confirmTarget.hidden = false
  }

  cancel(event) {
    event.preventDefault()
    this.confirmTarget.hidden = true
    this.triggerTarget.hidden = false
  }
}
